export default {
      id: "icon-search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }